module.exports = __webpack_public_path__ + "img/flags_right.d7e3bed3.svg";